var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconToggleName(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_toggle_name") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_toggle_name",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,8 C16,3.581722 12.418278,0 8,0 C3.581722,0 0,3.581722 0,8 L16,8 Z",
    id: "Oval",
    fill: "#738692"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4835977,15.5 C15.2263047,11.5909841 11.9741213,8.5 8,8.5 C4.02587865,8.5 0.77369532,11.5909841 0.516402277,15.5 L15.4835977,15.5 Z",
    id: "Oval",
    stroke: "#D1D7DA",
    fill: "#D1D7DA",
    transform: "translate(8.000000, 12.000000) scale(1, -1) translate(-8.000000, -12.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconToggleName);
export default __webpack_public_path__ + "static/media/icon_toggle_name.9dd01f4ad79c00d16dbff4a182f32da4.svg";
export { ForwardRef as ReactComponent };